import { createStore, applyMiddleware, compose } from 'redux'
import { enhanceReduxMiddleware } from '@eqworks/kepler.gl/middleware'
import thunkMiddleware from 'redux-thunk'

import rootReducer from '../modules'


export function configureStore() {
  const middlewares = enhanceReduxMiddleware([
    thunkMiddleware,
  ])

  const composeEnhancers = typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      actionSanitizer: (action) => (
        action.type.indexOf('@@kepler.gl') === 0
          ? { ...action, payload: '<<KEPLER_PAYLOAD>>' } : action
      ),
      stateSanitizer: (state) => (state.keplerGl
        ? { ...state, keplerGl: '<<KEPLER_STATE>>' } : state),
    }) : compose

  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares)),
  )

  if (module.hot) {
    module.hot.accept('../modules', () => {
      store.replaceReducer(rootReducer)
    })
  }

  return { store }
}
